<div>
  <app-retail-vs-municipalities-vs-other-filters *ngIf="years"
    [years]="years"
    (search)="searchData($event)">
  </app-retail-vs-municipalities-vs-other-filters>
  <mat-divider></mat-divider>
  <app-retail-vs-municipalities-vs-other-bar-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data">
  </app-retail-vs-municipalities-vs-other-bar-chart>
</div>
